import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class RecentlyViewedManager extends UcoastEl {
	static htmlSelector = 'recently-viewed-manager'
	viewedProductHandles: string[]
	handle: string | undefined

	constructor() {
		super()
		const textContent = q.rs<HTMLScriptElement>(
			'[type="application/json"]',
			this
		).textContent
		if (!textContent) throw new Error('History data not found')
		this.viewedProductHandles = JSON.parse(textContent)?.viewedProductHandles ?? []
		this.handle = this.getHandle()
		this.updateViewedProducts()
		this.updateCartAttribute()
	}

	getHandle(): string | undefined {
		const currentUrl = window.location.href.split('?')[0]
		if (!currentUrl.includes('/products/')) return undefined
		const handle = currentUrl.split('/products/')[1]
		return handle || undefined
	}

	updateViewedProducts() {
		if (!this.handle) return
		this.viewedProductHandles = this.viewedProductHandles.filter(h => h !== this.handle)
		this.viewedProductHandles.unshift(this.handle)
		this.viewedProductHandles = this.viewedProductHandles.slice(0, 10)
	}

	updateCartAttribute() {
		if (!this.handle) return
		console.log('updating attributes', this.viewedProductHandles)
		void fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					'_viewed_product_handles': this.viewedProductHandles
				}
			})
		})
	}
}
